import { get } from 'lodash';

function getItemResult(result) {
  return get(result, 'item.result', {});
}

export default getItemResult;
